import { useContext } from "react"
import { SurveyContext } from "../Main/SurveyContext"
import Icon from "../Icon"
import { toCamelCase } from "~/util/toCamelCase"

export const SurveyProgressCards = ({
  surveyEstimates,
  onOpenSurvey
}: {
  surveyEstimates: Record<
    string,
    { name: string; estimatedTimeToComplete: number }
  >
  onOpenSurvey: (surveyId: string) => void
}): JSX.Element => {
  const context = useContext(SurveyContext)
  if (!context) return <></>
  const surveyIdsArray = Object.keys(context.status)

  return (
    <ul className=" flex flex-col gap-1.5">
      {surveyIdsArray.map((surveyId, index) => {
        const surveyEstimate = surveyEstimates[toCamelCase(surveyId)]
        const isFinished = context.status[surveyId]
        return (
          <li key={index} className="block">
            <button
              className={`w-full text-left flex flex-row p-4 rounded-3xl gap-[2px] ${isFinished ? "bg-primary-50" : "bg-white"} relative overflow-hidden justify-between`}
              onClick={() => onOpenSurvey(surveyId)}
              disabled={isFinished}
            >
              <div className={`flex flex-row justify-between text-sm`}>
                <div className="flex flex-col flex-1">
                  <span
                    className={`${isFinished ? "text-neutral-300" : "text-primary-700"} font-medium`}
                  >
                    Spørgeskema {index + 1}
                  </span>
                  <p
                    className={`${isFinished ? "text-neutral-300" : "text-black"} text-xl font-semibold`}
                  >
                    {surveyEstimate.name}
                  </p>
                </div>
              </div>
              {isFinished && (
                <div className="flex justify-center content-center items-center">
                  <div className="bg-success-300 w-8 h-8 flex justify-center items-center rounded-full">
                    <Icon name="check" className="w-5 h-5 text-success-50" />
                  </div>
                </div>
              )}
              {!isFinished && (
                <div className="flex items-start font-medium">
                  <div className="flex justify-start items-center gap-1 text-sm text-primary-700">
                    <Icon name="stopWatchSimple" className="w-4 h-4" />
                    <span>ca.</span>
                    <span>{surveyEstimate.estimatedTimeToComplete}</span>
                    <span>min.</span>
                  </div>
                </div>
              )}
            </button>
          </li>
        )
      })}
    </ul>
  )
}
